<template>
    <gofix-card class="cardTable chartOfAccount job-calendar-page"  v-bind:class="{'run-loading':loadingData}"  fullContent>
        <!-- year & month dropdown -->
            <b-row>
                <b-col md="12">
                    <b-row>
                        <b-col md="2">
                            &nbsp;
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="1" class="ml-10">
                            <gofix-form-dropdown
                                        label="Year"
                                        :clearable="false"
                                        :filterable="false" 
                                        :searchable="false"
                                        :options="years"
                                        v-model="year">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="2">
                            <gofix-form-dropdown
                                    label="Maint. Program"
                                    vLabel="description_one"
                                    :clearable="false"
                                    :filterable="false" 
                                    :options="maintPrograms"
                                    v-model="maintProgram"
                                    :placeholder="'Maint. Program'">
                                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                    <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                                </template>
                                <template slot="gofixInput:dropdown:option" slot-scope="option">
                                    <div class="maintOption">
                                        <span>{{ option.description_one || '-' }}</span>
                                    </div>
                                </template>
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="2">
                            <gofix-form-properties
                                    valueFormat="object"
                                    label="Property"
                                    :contract-id="contract_id"
                                    v-model="location_info"
                                    :clearable="false"
                                    >
                            </gofix-form-properties>
                        </b-col>
                        <b-col md="2">
                            <gofix-form-tree
                                        label="Equipment Group"
                                        :multiple="false"
                                        :options="treeEquips"
                                        :load-options="loadOptionsEquiment"
                                        :normalizer="normalizerEquipment"
                                        search-nested
                                        valueFormat="object"
                                        v-model="equipment_structure_type"
                                        placeholder="Select"
                                        ref="equipmentTree">
                                </gofix-form-tree>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12" >
                    <!-- Equipment -->
                    <div class="div-calendar" v-show="equipment_structure_type">
                        <table class="table table-fixed table-bordered w-100 table-monthly">
                            <tr>
                                <th class="th-location">
                                    Location
                                </th>
                                <th class="th-equipment">
                                    Equipment
                                </th>
                                <th v-for="imonth in months" v-bind:key="'prop-th-'+imonth.month" class="th-month">
                                    {{imonth.name}}
                                </th>
                            </tr>
                            <tr v-for="eqm in equipmentItems.equipments" v-bind:key="eqm.id" class="job-status">
                                <td class="tb-location-label tb-label" v-bind:title="eqm.root_path">
                                    {{eqm.root_path}}
                                </td>
                                <td class="tb-equipment-label tb-label">
                                    {{eqm.tag_name}}
                                </td>
                                <td v-for="imonth in months" v-bind:key="'eqm-td-'+eqm.id+'-'+imonth.month" class="job-item">
                                    <template v-if="equipmentItems.calendarJobs[eqm.id].jobs && equipmentItems.calendarJobs[eqm.id].jobs[imonth.month]">
                                        <template v-if="equipmentItems.calendarJobs[eqm.id].jobs[imonth.month].type == 'Single'">
                                            <div v-bind:class="equipmentItems.calendarJobs[eqm.id].jobs[imonth.month].item.job_status" 
                                                v-bind:title="equipmentItems.calendarJobs[eqm.id].jobs[imonth.month].item.planned_date">                                            
                                                <router-link target="_blank" :to="`/v2/job-list/${equipmentItems.calendarJobs[eqm.id].jobs[imonth.month].item.id}`">
                                                    {{equipmentItems.calendarJobs[eqm.id].jobs[imonth.month].item.frequency}}
                                                </router-link>
                                            </div>
                                        </template>
                                        <template v-if="equipmentItems.calendarJobs[eqm.id].jobs[imonth.month].type == 'Overlap'">
                                            <b-btn v-bind:id="'exPop'+'-'+eqm.id+'-'+imonth.month" title="Overlap"></b-btn>
                                            <b-popover v-bind:target="'exPop'+'-'+eqm.id+'-'+imonth.month" triggers="focus">
                                                <div class="popoverWrapper">
                                                    <div v-for="o_job in equipmentItems.calendarJobs[eqm.id].jobs[imonth.month].item" v-bind:key="o_job.id"
                                                        v-bind:class="o_job.job_status" v-bind:title="o_job.planned_date"
                                                        class="div-overlap">
                                                        <router-link target="_blank" :to="`/v2/job-list/${o_job.id}`">
                                                            {{o_job.frequency}}
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </b-popover>
                                        </template>
                                    </template>
                                </td> 
                            </tr>
                        </table>           
                        <b-row class="m-0">
                            <b-col>                                            
                                <nav>
                                    <b-pagination :total-rows="equipmentTotalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                                </nav>
                            </b-col>
                            <b-col>
                                <status id="eqm-monthly-status"></status>                                
                            </b-col>
                        </b-row> 
                    </div>
                    <!-- Property -->
                    <div class="div-calendar" v-show="!equipment_structure_type">
                        <table class="table table-fixed table-bordered w-100 table-monthly">
                            <tr>
                                <th class="th-prop-location-weekly">
                                    Location
                                </th>
                                <th v-for="imonth in months" v-bind:key="'prop-th-'+imonth.month" class="th-month">
                                    {{imonth.name}}
                                </th>
                            </tr>
                            <tr v-for="property in propertyItems.properties" v-bind:key="'prop-tr-'+property.property_id" class="job-status">
                                <td class="tb-label tb-location-label" v-bind:title="property.root_path">
                                    {{property.root_path}}
                                </td>
                                <td v-for="imonth in months" v-bind:key="'prop-td-'+property.property_id+'-'+imonth.month" class="job-item">
                                    <template v-if="propertyItems.calendarJobs[property.property_id].jobs && propertyItems.calendarJobs[property.property_id].jobs[imonth.month]">
                                        <template v-if="propertyItems.calendarJobs[property.property_id].jobs[imonth.month].type == 'Single'">
                                            <div v-bind:class="propertyItems.calendarJobs[property.property_id].jobs[imonth.month].item.job_status"
                                                v-bind:title="propertyItems.calendarJobs[property.property_id].jobs[imonth.month].item.planned_date">                                            
                                                <router-link target="_blank" 
                                                :to="`/v2/job-list/${propertyItems.calendarJobs[property.property_id].jobs[imonth.month].item.id}`">
                                                    {{propertyItems.calendarJobs[property.property_id].jobs[imonth.month].item.frequency}}
                                                </router-link>
                                            </div>
                                        </template>
                                        <template v-if="propertyItems.calendarJobs[property.property_id].jobs[imonth.month].type == 'Overlap'">
                                            <b-btn v-bind:id="'exPop'+'-'+property.property_id+'-'+imonth.month" title="Overlap"></b-btn>
                                            <b-popover v-bind:target="'exPop'+'-'+property.property_id+'-'+imonth.month" triggers="focus">
                                                <div class="popoverWrapper">
                                                    <div v-for="o_job in propertyItems.calendarJobs[property.property_id].jobs[imonth.month].item" v-bind:key="o_job.id"
                                                        v-bind:class="o_job.job_status" v-bind:title="o_job.planned_date"
                                                        class="div-overlap">
                                                        <router-link target="_blank" :to="`/v2/job-list/${o_job.id}`">
                                                            {{o_job.frequency}}
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </b-popover>
                                        </template>
                                    </template>
                                </td>
                            </tr>
                        </table>       
                               
                        <b-row class="m-0">
                            <b-col>                                            
                                <nav>
                                    <b-pagination :total-rows="propertyTotalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                                </nav>
                            </b-col>
                            <b-col>
                                <status id="prop-monthly-status"></status>                               
                            </b-col>
                        </b-row> 
                    </div>
                </b-col>
            </b-row>
    </gofix-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {LOAD_CHILDREN_OPTIONS} from '@riophae/vue-treeselect';
const status = () => import('./status')
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500);
};

import moment from 'moment';
export default {
    name: 'job-calendar-mothly',
    components: {
        status
    },
    data() {
        return {
            loadings:{
                service:false,
                equipment:false,
                property:false,
            },
            years: [],
            year: 0,
            months: [],
            month: '',
            days: [],
            months: [],
            currentPage: 1,
            perPage: 100,
            loadingData: false,
            maintProgram: {
                id: 'all',
                description_one: 'All'
            },
            maintPrograms: [],
            location_info: null,
            equipment_structure_type: null,
            treeEquips: [],
            contract_id: 0,
            contract_term_id: 0,
            property_root : null,
            init: true,
        }
    },
    computed: {
        ...mapGetters({
            ClientContractID: "ContractController/ClientContractID",
            equipmentItems: 'JobCalendarController/EquipmentMonthlyItems',
            equipmentTotalRows: 'JobCalendarController/EquipmentMonthlyTotalRows',
            propertyItems: 'JobCalendarController/PropertyMonthlyItems',
            propertyTotalRows: 'JobCalendarController/PropertyMonthlyTotalRows',
            ContractTermSelect: 'ContractController/ContractTermSelect',
            EquipmentStructureType: 'JobCalendarController/EquipmentStructureType',
            LocationInfo: 'JobCalendarController/LocationInfo',
            MaintProgram: 'JobCalendarController/MaintProgram',
            Year: 'JobCalendarController/Year',
        })
    },
    async created() {
        if(this.ClientContractID && this.ClientContractID.contract_terms){
            this.contract_id      = this.ClientContractID.id;
            this.contract_term_id = this.ClientContractID && this.ClientContractID.contract_terms && this.ClientContractID.contract_terms[0] ? this.ClientContractID.contract_terms[0].id : null;
            if(this.EquipmentStructureType && this.EquipmentStructureType.id)this.equipment_structure_type = this.EquipmentStructureType;
            if(this.MaintProgram && this.MaintProgram.id)this.maintProgram = this.MaintProgram;
            this.getInitData();
            await this.getMaintProgram();
            await this.getEquipsType(0, this.contract_id, 'all',true);
            if(this.LocationInfo && this.LocationInfo.id){
                this.location_info = this.LocationInfo;
                this.init = false;
            }
            else {
                await this.loadRootProperty();
            }
        }else{            
            return this.$alertNotification("Please choose a contract first.", "danger");
        }
    },
    methods: {
        getInitData(){
            this.loadingData = true;
            var iYear = parseInt(moment().format('YYYY'));
            if(this.Year) this.year = this.Year;
            else this.year = iYear;
            this.years.push(iYear-1);
            for(var i=0;i<3;i++){
                this.years.push(iYear);
                iYear++;
            }
            this.month = moment().format('MMMM');
            this.populateMonthHeaders();
        },
        populateMonthHeaders(){
            var mTime = moment(this.year+"-"+"January"+"-"+"01","YYYY-MMMM-DD");
            var iMonths = [];
            var i=1;
            while(i<=12){
                var dTime = mTime.clone();
                var obj = {};
                obj.month = i;
                obj.name = dTime.add(i-1,'month').format('MMM');
                iMonths.push(obj);
                i++;
            }
            this.months = iMonths;   
        },
        async getEquipmentTableData() {
            this.loadingData = true;
            var params = { year: this.year, filter: {}};
            this.populateMonthHeaders();
            var startDate = this.year + '-' + '01'+ '-' + '01';
            var endDate = this.year + '-' + '12'+ '-' + '31';

            var filter = {
                "location_id": {
                    "type": "number",
                    "value": this.location_info ? this.location_info.id : [],
                    "function": "=",
                    "with": []
                },
                "equipment_group_id": {
                    "type": "number",
                    "value": this.equipment_structure_type ? this.equipment_structure_type.id : 0,
                    "function": "=",
                    "with": []
                },
                "contract_id": {
                    "type": "number",
                    "value": this.contract_id,
                    "function": "=",
                    "with": []
                },
                "equipment.is_active": {
                    "type": "boolean",
                    "value": true
                },
                "planned_date": {
                    "type": "date",
                    "value": [startDate, endDate],
                    "function": "<>",
                    "with": []
                }
            };

            if(this.maintProgram && this.maintProgram.id != 'all'){
                filter["maintenance_id"] ={
                    "type": "number",
                    "value": this.maintProgram.id,
                    "function": "=",
                    "with": []
                };
            }

            params.filter = filter;
            params.page = this.currentPage;
            params.limit = 100;
            params.mode = "monthly";

            await this.$store.dispatch("JobCalendarController/getEquipmentMonthlyItems", params)
                .then(response => {
                    this.loadingData = false;
                })
                .catch(err => {
                    this.$alertNotification("Can not load the job calendar", "danger");
                    console.log(err);
                    this.loadingData = false;
                })
        },

        async getPropertyTableData() {
            this.loadingData = true;
            var params = { year: this.year, filter: {}};
            
            if(this.location_info){
                params.location_id = this.location_info.id;
            }

            this.populateMonthHeaders();
            var startDate = this.year + '-' + '01'+ '-' + '01';
            var endDate = this.year + '-' + '12'+ '-' + '31';

            var filter = {
                "location_id": {
                    "type": "number",
                    "value": [],
                    "function": "=",
                    "with": []
                },
                "equipment_group_id": {
                    "type": "number",
                    "value": 0,
                    "function": "=",
                    "with": []
                },
                "contract_id": {
                    "type": "number",
                    "value": this.contract_id,
                    "function": "=",
                    "with": []
                },
                "equipment.is_active": {
                    "type": "boolean",
                    "value": true
                },
                "planned_date": {
                    "type": "date",
                    "value": [startDate, endDate],
                    "function": "<>",
                    "with": []
                }
            };

            if(this.maintProgram && this.maintProgram.id != 'all'){
                filter["maintenance_id"] ={
                    "type": "number",
                    "value": this.maintProgram.id,
                    "function": "=",
                    "with": []
                };
            }

            params.filter = filter;
            params.page = this.currentPage;
            params.limit = 100;
            params.mode = "monthly";

            await this.$store.dispatch("JobCalendarController/getPropertyMonthlyItems", params)
                .then(response => {
                    this.loadingData = false;
                })
                .catch(err => {
                    this.$alertNotification("Can not load the job calendar", "danger");
                    console.log(err);
                    this.loadingData = false;
                })
        },
        
        async getMaintProgram(search = null, is_popup = false) {
            let filters = {
                search:             search,
                contract_term_id:   this.contract_term_id,
                is_maintenance:     true,
                is_master:          false
            }
            
            await this.$store.dispatch("v2SorController/getItems", {
                isCMS: false,
                page: -1,
                limit: 100,
                group_id: 0,
                filter: filters
            })
            .then(response => {
                if(!is_popup) {
                    this.maintPrograms = [{
                        id: 'all',
                        description_one: 'All'
                    }].concat(response.items);
                } else {
                }
            })
            .catch(err => {
                this.maintPrograms = [];
            })
        },
        ...mapActions({
            clearItemsState: 'JobCalendarController/clearEquipmentItems',
            setEquipmentStructureType: "JobCalendarController/setEquipmentStructureType",
            setMaintProgram: "JobCalendarController/setMaintProgram",
            setLocationInfo: "JobCalendarController/setLocationInfo",
            setYear: "JobCalendarController/setYear",
        }),
        refreshData(){
            if(!this.init){
                if(this.equipment_structure_type)
                    this.getEquipmentTableData();
                else
                    this.getPropertyTableData();
            }
        },
        loadOptionsEquiment({ action, parentNode, callback }) {
            if (action === LOAD_CHILDREN_OPTIONS ) {
                simulateAsyncOperation(async () => {
                    parentNode.children = await this.getEquipsType(parentNode.data.id, this.contract_id, 'all')
                    callback();
                })
            }
        },
        async getEquipsType(parent_id, contract_id, node_type,set = false) {
            this.loadings.equipment = true;
            let dataE = [];
            await global.axios(`api/equipment/tree-structure/${parent_id}`,
                {
                    method: "GET",
                    params: {
                        contract_id: contract_id,
                        node_type: node_type
                    },
                    headers: { Accept: "application/json", }
                })
                .then(response => {
                    dataE = response.data.data;
                    this.loadings.equipment = false;
                }).catch(error => {
                    this.loadings.equipment = false;
                });
            if(set){
                this.treeEquips = dataE;
            }else{
                return dataE
            }
        },
        normalizerEquipment(node) {
            if(node.isBatch) {
                return {
                    id: node.data.id,
                    label: node.data.name,
                    children: node.children
                }
            }
            return {
                id: node.id,
                label: node.name,
                children: undefined
            }
        },
        async loadRootProperty(){
            this.loadings.property = true;
            await global.axios(`api/contracts/${this.contract_id}/tree-properties/0`, {
                method: "GET",
                data: {},
                headers: {
                    Accept: "application/json",
                }
            })
            .then(result => {
                var location_info = {};
                location_info.id = result.data.data[0].id;
                location_info.name = result.data.data[0].name;
                this.location_info = location_info;
                this.loadings.property = false;
                this.init = false;
            })
            .catch(error => {
                this.loadings.property = false;
                this.init = false;
            });
        },
    },
    watch: {
        currentPage: {
            handler: function(value) {
                this.refreshData();
            }
        },
        month: {
            handler: function(value) {
                this.refreshData();
            }
        },
        year: {
            handler: function(value) {
                this.setYear(value);
                this.refreshData();
            }
        },
        ClientContractID: function(val, old){
            if(!val){
                this.$router.go();
            }
            else if((val && old && old.id && val.id !== old.id)||(!old && val)){
                this.contract_id      = this.ClientContractID.id;
                this.contract_term_id = this.ClientContractID && this.ClientContractID.contract_terms && this.ClientContractID.contract_terms[0] ? this.ClientContractID.contract_terms[0].id : null;
                this.equipment_structure_type = null;
                this.setEquipmentStructureType(null);
                this.getMaintProgram();
                this.getEquipsType(0, this.contract_id, 'all',true);
                this.loadRootProperty();
            }
        },
        maintProgram:  {
            handler: function(value) {
                this.setMaintProgram(value);
                this.refreshData();
            }
        },
        equipment_structure_type:  {
            handler: function(value) {
                this.setEquipmentStructureType(value);
                this.refreshData();
            }
        },
        location_info:  {
            handler: function(value) {
                this.setLocationInfo(value);
                this.refreshData();
            }
        },

  }
}
</script>
